// extracted by mini-css-extract-plugin
module.exports = {"phonePreviewContainer":"CPASDashboard_phonePreviewContainer__2WtHc","phonePreview":"CPASDashboard_phonePreview__1at1g"};